import {
  AuthTokenStatus,
  IntegrationConfig,
  IntegrationDetails,
  IntegrationListing,
} from '@fullstory/proto/fs/services/emissary';

export enum IntegrationsRequestTypes {
  GetAvailableIntegrationsRequest = 'integrations.available.get.request',
  GetAvailableIntegrationsSuccess = 'integrations.available.get.success',
  GetAvailableIntegrationsFailure = 'integrations.available.get.failure',
  GetInstalledIntegrationsRequest = 'integrations.installed.get.request',
  GetInstalledIntegrationsSuccess = 'integrations.installed.get.success',
  GetInstalledIntegrationsFailure = 'integrations.installed.get.failure',
  GetIntegrationDetailsRequest = 'integration.details.get.request',
  GetIntegrationDetailsSuccess = 'integration.details.get.success',
  GetIntegrationDetailsFailure = 'integration.details.get.failure',
  GetIntegrationDetailsByProviderIdRequest = 'integration.details.providerid.get.request',
  GetIntegrationDetailsByProviderIdSuccess = 'integration.details.providerid.get.success',
  GetIntegrationDetailsByProviderIdFailure = 'integration.details.providerid.get.failure',
  GetAuthUrlRequest = 'integration.authurl.get.request',
  GetAuthUrlSuccess = 'integration.authurl.get.success',
  GetAuthUrlFailure = 'integration.authurl.get.failure',
  InstallIntegrationRequest = 'integration.install.request',
  InstallIntegrationSuccess = 'integration.install.success',
  InstallIntegrationFailure = 'integration.install.failure',
  ConvertIntegrationScopeRequest = 'integration.installation.convertscope.request',
  ConvertIntegrationScopeSuccess = 'integration.installation.convertscope.success',
  ConvertIntegrationScopeFailure = 'integration.installation.convertscope.failure',
  UpdateInstalledIntegrationRequest = 'integration.installation.update.request',
  UpdateInstalledIntegrationSuccess = 'integration.installation.update.success',
  UpdateInstalledIntegrationFailure = 'integration.installation.update.failure',
  DisconnectIntegrationRequest = 'integration.connection.disconnect.request',
  DisconnectIntegrationSuccess = 'integration.connection.disconnect.success',
  DisconnectIntegrationFailure = 'integration.connection.disconnect.failure',
  DeprecatedInstallIntegrationRequest = 'integration.install.request.deprecated',
  DeprecatedInstallIntegrationSuccess = 'integration.install.success.deprecated',
  DeprecatedInstallIntegrationFailure = 'integration.install.failure.deprecated',
  CreateIntegrationConfigRequest = 'integration.config.create.request',
  CreateIntegrationConfigSuccess = 'integration.config.create.success',
  CreateIntegrationConfigFailure = 'integration.config.create.failure',
  UpdateIntegrationConfigRequest = 'integration.config.update.request',
  UpdateIntegrationConfigSuccess = 'integration.config.update.success',
  UpdateIntegrationConfigFailure = 'integration.config.update.failure',
  GetIntegrationUsersRequest = 'integration.users.get.request',
  GetIntegrationUsersSuccess = 'integration.users.get.success',
  GetIntegrationUsersFailure = 'integration.users.get.failure',
  UninstallIntegrationRequest = 'integration.uninstall.request',
  UninstallIntegrationSuccess = 'integration.uninstall.success',
  UninstallIntegrationFailure = 'integration.uninstall.failure',
  GetAuthTokenStatusesRequest = 'integrations.authstatus.get.request',
  GetAuthTokenStatusesSuccess = 'integrations.authstatus.get.success',
  GetAuthTokenStatusesFailure = 'integrations.authstatus.get.failure',
  GetAutocompleteValuesRequest = 'integrations.notes.autocomplete.get.request',
  GetAutocompleteValuesSuccess = 'integrations.notes.autocomplete.get.success',
  GetAutocompleteValuesFailure = 'integrations.notes.autocomplete.get.failure',
  ConnectIntegrationRequest = 'integrations.connect.request',
  ConnectIntegrationSuccess = 'integrations.connect.success',
  ConnectIntegrationFailure = 'integrations.connect.failure',
  GetIntegrationConfigSummariesRequest = 'integrations.configs.summaries.request',
  GetIntegrationConfigSummariesSuccess = 'integrations.configs.summaries.success',
  GetIntegrationConfigSummariesFailure = 'integrations.configs.summaries.failure',
  ValidateIntegrationsRequest = 'integrations.validate.request',
  ValidateIntegrationsSuccess = 'integrations.validate.success',
  ValidateIntegrationsFailure = 'integrations.validate.failure',
  ValidateIntegrationConfigOptionsRequest = 'integration.config.options.validate.request',
  ValidateIntegrationConfigOptionsSuccess = 'integration.config.options.validate.success',
  ValidateIntegrationConfigOptionsFailure = 'integration.config.options.validate.failure',
  DeleteIntegrationConfigRequest = 'integrations.config.delete.request',
  DeleteIntegrationConfigSuccess = 'integrations.config.delete.success',
  DeleteIntegrationConfigFailure = 'integrations.config.delete.failure',
  GetIntegrationConfigOptionsRequest = 'integration.config.options.get.request',
  GetIntegrationConfigOptionsSuccess = 'integration.config.options.get.success',
  GetIntegrationConfigOptionsFailure = 'integration.config.options.get.failure',
  SendTestContentRequest = 'integrations.sendtestcontent.request',
  SendTestContentSuccess = 'integrations.sendtestcontent.success',
  SendTestContentFailure = 'integrations.sendtestcontent.failure',
}

export type AuthTokenStatuses = { [key: string]: AuthTokenStatus };

export type IntegrationData = {
  config: IntegrationConfig;
  details: IntegrationDetails;
  listing: IntegrationListing;
};
